<template>
    <MainContent v-if="categorias.length">
        <template v-slot:header>
            <h3 class="card-title pb-3">
                <span class="red">*</span><strong>Arrastre los precios para ordenarlos automáticamente</strong>
            </h3>
            <div class="card-tools">
                <router-link :to="{ name: 'back.productos.categorias' }" class="btn btn-primary" id="categorias">
                    Volver al listado
                </router-link>
            </div>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <h4 class="mb-4">Arrastra las categorías para ordenar la posición en la que quieres que aparezcan</h4>
                <draggable v-model="categorias" @end="onDragEnd" item-key="id" class="drag-container">
                    <div v-for="(categoria, index) in categorias" :key="categoria.id" :class="{'even': index % 2 === 0, 'odd': index % 2 !== 0}" class="row m-0 categoria-content draggable-item">
                        <div class="col-12 pl-1 mb-2 mb-md-0 pl-md-2 col-md-5">
                            <strong>Nombre:</strong> {{ categoria.name }}
                        </div>
                        <div class="col-12 pl-1 mb-2 mb-md-0 pl-md-2 col-md-5">
                            <strong>Descripción:</strong> {{ categoria.description }}
                        </div>
                        <div class="col-12 pl-1 mb-2 mb-md-0 pl-md-2 col-md-2">
                            <strong>Posición:</strong> {{ categoria.posicion }}
                        </div>
                    </div>
                </draggable>
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import draggable from "vuedraggable";

export default {
    data() {
        return {
            loading: false,
            categorias: []
        }
    },
    methods: {
        getCategorias() {
            this.loading = true;

            const params = {
                filters : {
                    to_select: true
                },
                teatro_id: this.teatro.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.categorias.index'), params).then(res => {
                this.categorias = res.data.data;
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        onDragEnd() {
            this.categorias.forEach((categoria, index) => {
                categoria.posicion = index + 1;
                this.modificarOrdenCategoria(categoria);
            });
            this.$toast.success('Orden modificado correctamente.');
        },
        modificarOrdenCategoria(categoria) {
            this.loading = true;
            categoria.teatro_id = this.teatro.id;
            categoria.category_id = categoria.id;

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.categorias.editar'), categoria).then(() => {
            }).catch(error => {
                this.$toast.error(error.response?.data?.message);
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    created() {
        this.getCategorias();
    },
    components: {
        MainContent,
        draggable
    }
};
</script>

<style scoped>
    .even {
        background-color: #f8f9fa;
    }

    .odd {
        background-color: #ffffff;
    }

    .categoria-content {
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        margin-bottom: 5px;
        cursor: grab;
        font-size: 20px;
    }

    .drag-container {
        min-height: 50px;
    }

    .draggable-item {
        transition: background-color 0.3s;
    }

    .draggable-item:active {
        background-color: #f0f0f0;
    }

    .draggable-item:hover {
        cursor: grab;
    }

    .drag-handle {
        cursor: pointer;
    }
</style>
